import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Button,
    Box,
    Avatar,
    Chip
} from '@mui/material';
import {
    Schedule,
    Speed,
    Psychology
} from '@mui/icons-material';

const RateLimitDialog = ({ open, onClose, errorData }) => {
    if (!errorData) return null;

    const getDialogConfig = () => {
        switch (errorData.messageType) {
            case 'rate_limit':
                return {
                    icon: <Schedule sx={{ fontSize: 40, color: 'orange' }} />,
                    title: "Vaqt ajrating",
                    color: 'warning',
                    subtitle: null
                };
            case 'burst_limit':
                return {
                    icon: <Speed sx={{ fontSize: 40, color: 'red' }} />,
                    title: "Juda tez!",
                    color: 'error',
                    subtitle: null
                };
            case 'slow_down':
                return {
                    icon: <Psychology sx={{ fontSize: 40, color: 'purple' }} />,
                    title: "Diqqat bilan o'qing",
                    color: 'secondary',
                    subtitle: null
                };
            default:
                return {
                    icon: <Schedule sx={{ fontSize: 40, color: 'blue' }} />,
                    title: "Biroz dam oling",
                    color: 'info',
                    subtitle: ""
                };
        }
    };

    const config = getDialogConfig();

    const getAdviceMessage = () => {
        switch (errorData.messageType) {
            case 'rate_limit':
                return "So'zni bosgandan keyin, matnning kontekstida uning ma'nosini o'ylab ko'ring. Bu chuqur tushunishga yordam beradi! 🧠";
            case 'burst_limit':
                return "Har bir so'zning matn ichidagi ma'nosini anglashga vaqt ajrating. Kontekst - kalit! 🔑";
            case 'slow_down':
                return "So'zni faqat tarjima qilmang, balki matn kontekstida uning ma'nosini tushunishga harakat qiling! 🌱";
            default:
                return "Har bir so'zni matn kontekstida chuqur o'rganishga vaqt ajrating! 📖";
        }
    };

    return (
        <Dialog 
            open={open} 
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    bgcolor: 'background.paper'
                }
            }}
        >
            <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                    <Avatar 
                        sx={{ 
                            width: 80, 
                            height: 80, 
                            bgcolor: `${config.color}.50`,
                            border: 2,
                            borderColor: `${config.color}.200`
                        }}
                    >
                        {config.icon}
                    </Avatar>
                    <Box sx={{ textAlign: 'center' }}>
                        <Typography variant="h5" fontWeight="600" color={`${config.color}.700`}>
                            {config.title}
                        </Typography>
                        {config.subtitle && (
                            <Chip 
                                label={config.subtitle}
                                color={config.color}
                                size="small"
                                variant="outlined"
                                sx={{ mt: 1 }}
                            />
                        )}
                    </Box>
                </Box>
            </DialogTitle>
            
            <DialogContent sx={{ textAlign: 'center', py: 3 }}>
                <Typography 
                    variant="h6" 
                    sx={{ 
                        mb: 3,
                        lineHeight: 1.6,
                        color: 'text.primary'
                    }}
                >
                    {errorData.messageUz || errorData.message}
                </Typography>
                
                <Box 
                    sx={{ 
                        p: 2, 
                        borderRadius: 2, 
                        bgcolor: `${config.color}.50`,
                        border: 1,
                        borderColor: `${config.color}.200`,
                        mb: 2
                    }}
                >
                    <Typography variant="body1" color={`${config.color}.800`}>
                        💡 <strong>Maslahat:</strong> {getAdviceMessage()}
                    </Typography>
                </Box>

                {/* {errorData.retryAfter && (
                    <Typography variant="body2" color="text.secondary">
                        ⏱️ {errorData.retryAfter} soniyadan keyin qayta urinib ko'ring
                    </Typography>
                )} */}
            </DialogContent>
            
            <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
                <Button 
                    onClick={onClose}
                    variant="contained"
                    color={config.color}
                    size="large"
                    sx={{ 
                        px: 4,
                        py: 1,
                        borderRadius: 2,
                        textTransform: 'none',
                        fontSize: '1rem'
                    }}
                >
                    Tushundim ✨
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default RateLimitDialog; 